<template>
  <AccessibilityStatementPage />
</template>

<script setup>
useHead({
  title: 'Proxify accessibility statement',
  meta: [
    {
      hid: 'description',
      name: 'description',
      content:
        'Proxify is committed to digital accessibility in compliance with the EU Accessibility Act (EAA). Learn about our efforts to ensure an inclusive online experience for all users.',
    },
    {
      hid: 'og:title',
      property: 'og:title',
      content: 'Proxify accessibility statement',
    },
    {
      hid: 'og:description',
      property: 'og:description',
      content:
        'Proxify is committed to digital accessibility in compliance with the EU Accessibility Act (EAA). Learn about our efforts to ensure an inclusive online experience for all users.',
    },
  ],
});
</script>
